import React, { FC } from 'react';

import { Grid, Typography } from '@mui/material';
import style from './style';

interface IInvoiceBox {
  title?: string;
  note?: string;
  showLabel?: boolean;
  show?: boolean;
  config: {
    label: string;
    value: string | number;
  }[];
}

const InvoiceBox: FC<IInvoiceBox> = ({ config, title, note, show = true, showLabel = true }) =>
  (
    <Grid container sx={[style.root, show ? {} : style.emptyRoot]}>
      {show && (
      <>
        {title && <Typography sx={style.title}>{title}</Typography>}
        {note && <Typography sx={style.note}>{note}</Typography>}

        {config.map((item) => {
          const { label, value } = item ?? {};

          return (
            <Grid key={label} sx={style.container} container>
              {showLabel && (
              <Grid item xs={7}>
                <Typography sx={style.label}>{label}</Typography>
              </Grid>
              )}
              <Grid item xs={showLabel ? 5 : 12}>
                <Typography sx={style.value}>{value}</Typography>
              </Grid>
            </Grid>
          );
        })}
      </>
      )}
    </Grid>
  );

export default InvoiceBox;
